import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2, Sparkles } from "lucide-react";

export default function LoginPage() {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  if (!loading && user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    const r = await login(email, password); setBusy(false);
    if (r.ok) nav("/"); else setErr(r.error);
  };
  return (
    <div className="min-h-screen flex bg-[#FAFAFB]">
      <div className="hidden lg:flex w-1/2 bg-gradient-to-br from-[#0F172A] via-[#1E1B4B] to-[#312E81] text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#7C3AED]/20 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#4F46E5]/20 blur-3xl" />
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-12">
            <div className="w-9 h-9 rounded-lg bg-white text-[#0F172A] flex items-center justify-center font-bold text-sm">KY</div>
            <div className="text-sm font-medium">Kamil Yıldırım CRM</div>
          </div>
          <div className="space-y-6">
            <h1 className="text-4xl xl:text-5xl font-bold leading-[1.05] tracking-tight">Ajansınızın komuta merkezi.</h1>
            <p className="text-white/70 text-lg leading-relaxed max-w-md">Müşteri, hizmet, görev, toplantı, eğitim, notlar, AI tools — hepsi tek panelde.</p>
          </div>
        </div>
        <div className="relative z-10 grid grid-cols-2 gap-3 max-w-md">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-3"><div className="text-[10px] uppercase tracking-wider text-[#A5B4FC] font-semibold mb-1">AI Araçları</div><div className="text-xs text-white/90">Anahtar kelime analizi, reklam metni, PDF raporlar — Gemini 2.5 Flash ile</div></div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-3"><div className="text-[10px] uppercase tracking-wider text-[#86EFAC] font-semibold mb-1">Google Workspace</div><div className="text-xs text-white/90">Meet linki otomatik, takvim daveti, Gmail entegrasyonu</div></div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-3"><div className="text-[10px] uppercase tracking-wider text-[#FCD34D] font-semibold mb-1">Müşteri Portalı</div><div className="text-xs text-white/90">PDF raporlar, dosya paylaşımı, destek talepleri</div></div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-3"><div className="text-[10px] uppercase tracking-wider text-[#F9A8D4] font-semibold mb-1">Notlar & Görevler</div><div className="text-xs text-white/90">Kategoriler, etiketler, checklist'ler, drag-drop kanban</div></div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="text-xs uppercase tracking-wider text-[#94A3B8] font-semibold">Ekip Girişi</div>
          <h2 className="text-3xl font-bold mt-2">Hoş geldiniz</h2>
          <p className="text-sm text-[#64748B] mt-2">Ajansınız için tasarlanmış komuta merkezine giriş yapın.</p>
          <div className="mt-8 space-y-4">
            <div>
              <label className="block text-xs font-medium text-[#64748B] mb-1.5">E-posta</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="ky-input" placeholder="ornek@kamilyildirim.com" />
            </div>
            <div>
              <label className="block text-xs font-medium text-[#64748B] mb-1.5">Şifre</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="ky-input" placeholder="••••••••" />
            </div>
            {err && <div className="text-sm px-3 py-2 rounded-md bg-[#FEF2F2] text-[#DC2626] border border-[#FECACA]" data-testid="login-error">{err}</div>}
            <button type="submit" disabled={busy} className="ky-btn ky-btn-accent w-full h-10" data-testid="login-submit">
              {busy && <Loader2 size={14} className="animate-spin" />}Giriş yap
            </button>
            <div className="text-xs text-[#94A3B8] pt-4 border-t border-[#ECECEF]">
              <Link to="/portal/login" className="ky-link">Müşteri girişi →</Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
